export default __webpack_public_path__ + "static/media/251035.cda1a4d7.png";